module.exports = require('./helpers/bundle-url').getBundleURL('ekZ4q') + "merge-checks-empty-state.9f3f5bf0.svg";